import { mapGetters, mapMutations } from 'vuex';
import addPackageOrderProduct from './../../components/addPackageOrderProduct/addPackageOrderProduct.vue';
import editPackageOrderProduct from './../../components/editPackageOrderProduct/editPackageOrderProduct.vue';
import editPackage from './../../components/editPackage/editPackage.vue';
import packageOrderProductService from './../../services/packageOrderProduct';
import orderProductService from './../../services/orderProduct';
import packageService from './../../services/package';

export default {
  data() {
    return {
      pallet_number: 0,
      activeNames: [],
      packageIdIterator: 0,
      selectedPaperSize: '102x192mm',
      paperSizes: [
        { value: '102x192mm', name: '102x192mm' },
        { value: 'A4', name: 'A4' },
        { value: 'A5', name: 'A5' },
        { value: 'A6', name: 'A6' },
      ],
    };
  },

  props: {
    /**
     * The current order.
     */
    order: {
      type: Object,
      required: true,
    },

    /**
     * The list of packages order.
     */
    packages: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      products: 'allProducts',
      orderProducts: 'allOrderProducts',
      currentEdiOrder: 'currentEdiOrder',
      taxes: 'allTaxes',
      productDeposits: 'allProductDeposits',
      packageOrderProducts: 'allPackageOrderProducts',
      currentOrder: 'currentOrder',
    }),
  },

  watch: {},

  created() {
    const allPackages = this.packages.all;
    for (var i = 0; i <= allPackages.length; i++) {
      this.activeNames.push(i);
    };
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * Open the addPackageOrderProduct modal
     */
    activateAddProductToPackageModal(id) {
      const palletDetails = { packageId: id };
      this.setModalContent(() => addPackageOrderProduct);
      this.setModalProps(palletDetails);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /**
     * Open the editPackageOrderProduct modal
     */
    activateEditProductToPackageModal(selectedPackageOrderProduct) {
      this.setModalContent(() => editPackageOrderProduct);
      this.setModalProps(selectedPackageOrderProduct);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /**
     * Open the editPackageOrderProduct modal
     */
    activateEditPacakge(pckg) {
      this.setModalContent(() => editPackage);
      this.setModalProps(pckg);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    getPackageOrderProductById(id) {
      return this.packageOrderProducts.all.filter(function(p) {
        return p.packageId == id;
      });
    },

    editpackageOrderProduct(selectedPackageOrderProduct) {
      this.activateEditProductToPackageModal(selectedPackageOrderProduct);
    },

    confirmToRemovePackage(selectedPackageOrderProduct) {
      this.$confirm(this.$t("static.packageOrderProduct.destroy.confirm"), 'Confirm', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.removeProductFromPackage(selectedPackageOrderProduct.id)
      }).catch(() => {});
    },

    confirmDeletePackage(packageId) {
      this.$confirm(this.$t("static.package.destroy.confirm"), 'Confirm', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.deletePackage(packageId)
      }).catch(() => {});
    },

    /**
     * Calls the service responsible in removing the products to package
     */
    removeProductFromPackage(id) {
      const packageOrderProductDestroy = packageOrderProductService.destroy(id)
        .then(() => {
          orderProductService.all(this.currentOrder.id);
          packageOrderProductService.all(this.currentOrder.id)
          packageService.all(this.currentOrder.id)
          this.$message({
            showClose: true,
            message: this.$t('static.packageOrderProduct.destroy.success'),
            customClass: 'success',
          });
        })
        .catch(() => {
          let message = this.$t('static.packageOrderProduct.destroy.error');
          this.$message({
            showClose: true,
            message,
            customClass: 'error',
          });
        });
    },

    /**
     * Calls the service responsible in deleting the package and unassign any product inside of it
     */
    deletePackage(id) {
      const packageOrderProductDestroy = packageService.destroy(id)
        .then(() => {
          orderProductService.all(this.currentOrder.id);
          packageOrderProductService.all(this.currentOrder.id)
          packageService.all(this.currentOrder.id)
          this.$message({
            showClose: true,
            message: this.$t('static.package.destroy.success'),
            customClass: 'success',
          });
        })
        .catch(() => {
          let message = this.$t('static.package.destroy.error');
          this.$message({
            showClose: true,
            message,
            customClass: 'error',
          });
        });
    },

    viewProductBarcode(packageOrderProduct) {
      packageOrderProductService.show(packageOrderProduct.hashid);
    },

    viewPackageBarcode(packageId) {
      packageService.show(packageId, this.selectedPaperSize);
    },

    viewMixPalletPackageBarcode(packageId) {
      packageService.showMixPallet(packageId, this.selectedPaperSize);
    },
  },

  watch: {

  },

  mounted() {

  },
};



// WEBPACK FOOTER //
// ./src/app/components/managePackage/managePackage.js